module.exports = __webpack_public_path__ + "static/media/6.7ea1b8d2.jpg";